import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getUser } from '../../../reducers'
import LoadingPage from '../../components/LoadingPage'
import { firestore, db, cloudFunctions } from '../../../config/Fire'
import * as Constants from '../../../constants'
import { Col, Grid, Row } from 'react-flexbox-grid'
import { DatePicker, Button, Form, Select, Input, Tag } from 'antd'
import { MinusCircleOutlined } from '@ant-design/icons'
import TextArea from 'antd/lib/input/TextArea'
import TripsTable from '../../containers/TripsTable'
import './style.css'

const { Option } = Select

const WorksTripsEmployee = props => {
    const [works, setWorks] = useState({})
    const [trips, setTrips] = useState({})
    const [employeesFiltered, setEmployeesFiltered] = useState([])
    const [employees, setEmployees] = useState({})
    const [worksFiltered, setWorksFiltered] = useState([])
    const [loading, setLoading] = useState(true)
    const [form] = Form.useForm()
    
    useEffect(() => {
        async function getData () {
            setLoading(true)
            try {
                const workDocs = await firestore.collection(`${Constants.MAIN_NODES.WORK_ORDERS}`).get();
                const worksLoaded = {};
                if (!workDocs.empty) {
                    workDocs.forEach(workDoc => {
                        const work = workDoc.data();
                        worksLoaded[work.id] = work;
                    });
                }
                //setWorks(worksLoaded);
                const dataAr = [];
                for (let i = 0; i < Object.keys(worksLoaded).length; i++) {
                    const work = worksLoaded[Object.keys(worksLoaded)[i]];
                    const ot = getOTName(work, 'OT');
                    if (ot !== false) {
                        dataAr.push({
                            label: `${ot} - ${work.locality}`,
                            id: work.id
                        });
                    }
                }
                setWorks(dataAr);
                setWorksFiltered(dataAr);
                await getTrips()
            } catch (err) {
                console.log('Error getting works: ' + JSON.stringify(err));
            }
            db.ref(Constants.MAIN_NODES.USERS).once('value')
                .then(usersSnap => {
                    const employeesLoaded = {}
                    if (usersSnap.exists()) {
                        usersSnap.forEach(userSnap => {
                            const user = userSnap.val()
                            if (user.userType === Constants.USER_TYPES.EMPLOYEE) {
                                employeesLoaded[user.id] = user
                            }
                        })
                    }
                    setEmployees(employeesLoaded)
                })
                .catch(err => { 
                    console.log('Error getting users: ' + JSON.stringify(err))
                })
            setLoading(false);
        }
        getData()
    }, [])

    const getTrips = async () => {
        try {
            const tripDocs = await firestore.collection(`${Constants.MAIN_NODES.TRIPS}`).get();
            const tripsLoaded = [];
            if (!tripDocs.empty) {
                tripDocs.forEach(tripDoc => {
                    tripsLoaded.push(tripDoc.data());
                });
            }
            setTrips(tripsLoaded);
        } catch (err) {
            console.log('Error getting trips: ' + JSON.stringify(err));
        }
    }

    const getOTName = (record, value) => {
        if(record.SAT) {
            const workOrderTextFormat = `O/T SAT/${record['year'].toString().substring(2, 4)}`
            return (record['year'].toString().toLowerCase().includes(value.toLowerCase()) || workOrderTextFormat.toString().toLowerCase().includes(value.toLowerCase()))
        } else {
            const workOrderTextFormat = `O/T Nº${record['workOrderNumber']}/${record['year'].toString().substring(2, 4)}`
            return workOrderTextFormat //record['workOrderNumber'].toString().toLowerCase().includes(value.toLowerCase()) || record['year'].toString().toLowerCase().includes(value.toLowerCase()) || workOrderTextFormat.toString().toLowerCase().includes(value.toLowerCase())
        }
    }

    const handleSubmit = async values => {
        const userId = props.user.id;
        try {
            setLoading(true)
            const trip = {
                startDate: values.startDate ? values.startDate.format('DD/MM/YYYY') : '',
                endDate: values.endDate ? values.endDate.format('DD/MM/YYYY') : '',
                locality: values.locality !== undefined ? values.locality : '',
                description: values.description !== undefined ? values.description : '',
                workId: values.workId !== undefined ? values.workId[0] : '',
                workLabel: values.workId  !== undefined ? values.workId[1] : '',
                employeesId: (values.employeesId !== undefined && Array.isArray(values.employeesId)) ? values.employeesId : '',
                userId: userId
            }
            const tripRef = await firestore.collection(`${Constants.MAIN_NODES.TRIPS}`).add(trip);
            await tripRef.update({ id: tripRef.id });
            if (trip.workId !== '') {
                const workRef = firestore.collection(`${Constants.MAIN_NODES.WORK_ORDERS}`).doc(trip.workId);
                const workDoc = await workRef.get();
                const work = workDoc.data();
                const trips = work.trips || [];
                trips.push(tripRef.id);
                await workRef.update({ trips });
                const workOrderLabel = getOTLabel(work)
                work['workOrderLabel'] = workOrderLabel
                work['trip'] = trip
                const data = {
                    workOrderID: work.id,
                    type: 'OT_NEW_TRIP',
                    detailsOT: work,
                }
                cloudFunctions.sendEmails(data)
            }
            form.resetFields();
            await getTrips();
            setLoading(false);
        } catch (err) {
            console.log('Error adding trip: ' + JSON.stringify(err));
        }
    }

    const getOTLabel = (prop) => {
        const company = prop?.company === 'SD' ? 'SYD' : prop?.company === 'Arcasa' ? 'ARC' : 'O/T'
        if (prop.SAT) {
            return `${company} Nº${prop['workOrderNumber']}/${prop['year'].toString().substring(2, 4)} (SAT)`
        } else { 
            return `${company} Nº${prop['workOrderNumber']}/${prop['year'].toString().substring(2, 4)}`
        }
    }

    const removeTrip = async trip => {
        try {
            setLoading(true)
            await firestore.collection(`${Constants.MAIN_NODES.TRIPS}`).doc(trip.id).delete();
            if (trip.workId !== '') {
                const workRef = firestore.collection(`${Constants.MAIN_NODES.WORK_ORDERS}`).doc(trip.workId);
                const workDoc = await workRef.get();
                const work = workDoc.data();
                const trips = work.trips || [];
                const index = trips.indexOf(trip.id);
                if (index > -1) {
                    trips.splice(index, 1);
                }
                await workRef.update({ trips });
            }
            await getTrips();
            setLoading(false);
        } catch (err) {
            console.log('Error removing trip: ' + JSON.stringify(err));
        }
    }

    const filterWorks = value => {
        setWorksFiltered(works.filter(work => work.label.toLowerCase().includes(value.toLowerCase())));
    }

    const clearField = () => {
        form.resetFields();
    }

    const filterEmployees = value => {
        setEmployeesFiltered([])
        if (employees) {
            const valueLowerCase = value.toLowerCase()
            const employeesFinded = Object.values(employees).filter(employee => employee.email.toLowerCase().includes(valueLowerCase) ||
                (employee.name !== undefined && employee.name.toLowerCase().includes(valueLowerCase)))
            setEmployeesFiltered(employeesFinded)
        }
    }

    const saveKilometers = async (selectedTrip, kilometers) => {
        try {
            setLoading(true)
            const trip = selectedTrip
            const tripRef = firestore.collection(`${Constants.MAIN_NODES.TRIPS}`).doc(trip.id)
            await tripRef.update({ kilometers: kilometers })
            await getTrips()
            setLoading(false)
        } catch (err) {
            console.log('Error saving kilometers: ' + JSON.stringify(err))
        }
    }

    return (
        loading ?
            <LoadingPage />
            :
            <Grid className="worksEmployeeCont">
                <Row center="xs"style={{ marginBottom: '20px' }}>
                    <Col xs={12} md={6}>
                        <h2>Resumen de Viajes</h2>
                    </Col>
                </Row>
                <Form onFinish={handleSubmit} form={form}>
                    <Row center="xs">
                        <Col xs={12} md={4}>
                            <Form.Item name="startDate" style={{width: '100%'}} rules={[{ required: true, message: 'Por favor, ingrese fecha de inicio' }]}>
                                <DatePicker format={'DD/MM/YYYY'} placeholder="Fecha inicio" style={{ width: '100%' }}/>
                            </Form.Item>
                        </Col>
                        <Col xs={12} md={4}>
                            <Form.Item name="endDate" style={{width: '100%'}} rules={[{ required: true, message: 'Por favor, ingrese fecha de finalización' }]}>
                                <DatePicker format={'DD/MM/YYYY'} placeholder="Fecha fin" style={{ width: '100%' }}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="xs">
                        <Col xs={12} md={4}>
                            <Form.Item name="locality" rules={[{ required: true, message: 'Por favor, ingrese la localidad' }]}>
                                <Input placeholder="Localidad"/>
                            </Form.Item>
                        </Col> 
                        <Col xs={12} md={4}>
                            <Form.Item name="description">
                                <TextArea placeholder="Descripción"/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center='xs'>
                        <Col xs={12} md={4}>
                            <Form.Item name="employeesId">
                                <Select
                                    mode="multiple"
                                    maxTagCount={2}
                                    placeholder="Profesionales"
                                    filterOption={false}
                                    onSearch={filterEmployees}
                                    style={{ width: '100%' }}>
                                    {employeesFiltered.map(d => (
                                        d.enabled ?
                                            <Option
                                                key={d.id} value={d.id}>{`${d.name}`}</Option>
                                            :
                                            <Option disabled
                                                    key={d.id} value={d.id}>{`${d.name}`}&nbsp;
                                                <Tag icon={<MinusCircleOutlined/>}
                                                    color="red">Deshabilitado</Tag></Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={12} md={4}>
                            <Form.Item name="workId">
                                <Select
                                    showSearch
                                    maxTagCount={1}
                                    placeholder="OT asociada"
                                    filterOption={true}
                                    onSearch={filterWorks}
                                    style={{ width: '100%' }}>
                                    { worksFiltered.map(d => 
                                        d.label !== false ?
                                        <Option key={d.id} value={[d.id,d.label]}>{`${d.label}`}</Option>
                                        : null
                                    ) }
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="xs">
                        <Form.Item style={{ textAlign: 'center', marginRight: '30px' }}>
                            <Button type="primary" htmlType="submit" loading={loading}>
                                Guardar
                            </Button>
                        </Form.Item>
                        <Form.Item style={{ textAlign: 'center' }}>
                            <Button onClick={() => {clearField()}} loading={loading}>
                                Limpiar
                            </Button>
                        </Form.Item>
                    </Row>
                </Form>
                <Row center="xs">
                    <Col xs={12}>
                        <TripsTable
                            data={trips}
                            employees={employees}
                            loading={loading} onRemoveTrip={removeTrip}
                            onAddKilometers={saveKilometers}
                        />
                    </Col>
                </Row>
            </Grid>
    )
};

const mapDispatchToPropsActions = dispatch => ({})

const mapStateToProps = state => ({
    user: getUser(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(WorksTripsEmployee));